import user from "../store/modules/user";

const mapSettings = {
  apiKey: "b32e35ac-7c5f-4b34-b907-823aeaebdcca", // `${user.state.ymk}`
  lang: "ru_RU",
  coordorder: "latlong",
  version: "2.1",
};
export { mapSettings };
